import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { Observable, throwError } from "rxjs";
import { CommonDataService } from "../../../common/services/commonData.service";
import { environment } from "src/environments/environment";

@Injectable()
export class FileService {
  isValid: boolean;

  constructor(
    private _toaster: ToastrService,
    private _commonDataService: CommonDataService
  ) { }
  uploadFile<T>(
    event: any,
    fileType: any,
    isDisableUploadLimit = false
  ): Observable<T> {
    this.isValid = true;
    const formData: FormData = new FormData();
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const fileSize = files[i].size;
      const fileName = files[i].name;
      const fileDetails = fileName.split(".");
      const ext = fileDetails.reverse()[0].toLowerCase();
      if (!isDisableUploadLimit && fileSize > 5242880) {
        this.isValid = false;
        this._toaster.warning("Please upload less than 5MB");
        return throwError("Format error");
       }
      if (
        fileType.fileType === "RESUME" &&
        (ext === "pdf" || ext === "doc" || ext === "docx")
      ) {
        formData.append("file[]", files[i], fileName);
      } else if (
        ["PASSPORT", "PAN", "IDENTITY_PROOFS"].includes(fileType.fileType) &&
        (ext === "jpg" || ext === "png" || ext === "jpeg")
      ) {
        formData.append("file[]", files[i], fileName);
      } else if (
        fileType.fileType != "RESUME" &&
        !["PASSPORT", "PAN", "IDENTITY_PROOFS"].includes(fileType.fileType) &&
        (ext === "png" || ext === "jpg" || ext === "jpeg" || ext === "pdf")
      ) {
        formData.append("file[]", files[i], fileName);
      } else {
        this.isValid = false;
        this._toaster.warning("Please upload valid format jpg , jpeg & png");
        return throwError("Format error");
      }
    }
    if (this.isValid) {
      if (
        fileType.fileType === "CERTIFICATES") {
        return this._commonDataService
          .postUploadDataAsync(`api/Profile/UploadFiles`, formData, fileType);
      }
      else if (fileType.fileType === "VERIFIEDDOCS"
      ) {
        return this._commonDataService
          .postUploadDataAsync(`api/Profile/UploadFiles`, formData, fileType);
      }
      else {
        return this._commonDataService
          .postUploadDataAsync(`api/Profile/UploadFile`, formData, fileType);
      }
    }
  }

  pdfToImageConverter<T>(
    event: any
  ): Observable<T> {
    this.isValid = true;
    const formData: FormData = new FormData();
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      const fileSize = files[i].size;
      const fileName = files[i].name;
      const fileDetails = fileName.split(".");
      const ext = fileDetails.reverse()[0].toLowerCase();
      if (fileSize > 5242880) {
        this.isValid = false;
        this._toaster.warning("Please upload less than 5MB");
        return throwError("Format error");
      }
      if (
        ext === "pdf"
      ) {
        formData.append("file[]", files[i], fileName);
      } else {
        this.isValid = false;
        this._toaster.warning("Please upload valid format jpg , jpeg & png");
        return throwError("Format error");
      }
    }
    if (this.isValid) {
      return this._commonDataService
        .ExternalPostDataNoTokenBlobAsync(`${environment.pdfUrl}api/pdfReport/PdfToImageConverter`, formData);
    }
  }

  deleteFileFromTemp<T>(data: any): Observable<T> {
    return this._commonDataService
      .postDataAsync(`api/admin/deleteFileFromTemp`, data);
  }

  uploadBase64<T>(base64Data: string, fileType: any): Observable<T> {
    // Convert base64 to Blob and upload using existing upload endpoint
    const formData: FormData = new FormData();
    const blob = this.dataURItoBlob(base64Data);
    // append as file[] to match server expectation
    formData.append("file[]", blob, "signature.png");

    // Use same upload endpoint as uploadFile
    return this._commonDataService.postUploadDataAsync(`api/Profile/UploadFile`, formData, fileType);
  }

  private dataURItoBlob(dataURI: string): Blob {
    // dataURI example: data:image/png;base64,....
    const byteString = atob(dataURI.split(",")[1]);
    const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
}
